import React from "react";
import { Box, Typography, Paper, Button } from "@mui/material";
import { Link as ScrollLink } from "react-scroll";
import { useTranslation } from "react-i18next";
import femmeVelo from "../../assets/couple-velo.png";

const HeroSection = () => {
  const { t } = useTranslation("partenaires/HeroSection");

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 5, px: 2 }}>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: "1200px",
          borderRadius: "20px",
          px: { xs: 3, md: 6 },
          pt: { xs: 4, md: 6 },
          pb: { xs: 4, md: 3 },
          backgroundColor: "#F8F8F8", // fix: "#FFFFF" -> "#FFFFFF"
          position: "relative",
          fontFamily: "'Poppins', sans-serif",
          overflow: "hidden",
        }}
      >
        <Box sx={{ zIndex: 2 }}>
          <Typography
            gutterBottom
            sx={{
              color: "#000000",
              fontWeight: 900,
              fontSize: { xs: "2.2rem", md: "3.5rem" },
              lineHeight: 1.2,
              maxWidth: { xs: "100%", md: "65%" },
              mb: 2,
            }}
          >
            {t("title.part1")}{" "}
            <Box component="span" sx={{ color: "#449F2D" }}>
              {t("title.highlight")}
            </Box>
          </Typography>

          <Typography
            sx={{
              color: "#000000",
              fontWeight: 500,
              fontSize: "1.1rem",
              lineHeight: 1.6,
              mb: 4,
              maxWidth: { xs: "100%", md: "600px" },
            }}
          >
            {t("subtitle")}
          </Typography>

          <Box sx={{ display: "flex", justifyContent: { xs: "center", md: "flex-start" } }}>
            <ScrollLink to="formulaire" smooth={true} duration={500} offset={-80}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#449F2D",
                  color: "#fff",
                  fontWeight: 600,
                  textTransform: "none",
                  borderRadius: "999px",
                  px: 3,
                  py: 1,
                  fontSize: "1rem",
                  "&:hover": {
                    backgroundColor: "#3A8C27",
                    transform: "scale(1.05)",
                    transition: "all 0.2s ease-in-out",
                  },
                }}
              >
                {t("cta")}
              </Button>
            </ScrollLink>
          </Box>
        </Box>

        <Box
          component="img"
          src={femmeVelo}
          alt={t("imageAlt")}
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            height: "360px",
            zIndex: 1,
            objectFit: "contain",
            pointerEvents: "none",
            display: { xs: "none", md: "block" },
          }}
        />
      </Paper>
    </Box>
  );
};

export default HeroSection;